<template>
  <div>
    <div>
      <input type="file" v-on:change="upload($event.target.files)" accept="image/*">
    </div>
    <iframe v-bind:src="imgUrl" frameborder="0"></iframe>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    tutor: Object
  },
  data () {
    return {
      imgUrl: '',
      cloudinary: {
        uploadPreset: 'hitx3cix',
        apiKey: '488353543644961',
        cloudName: 'dsvd2yusw'
      }
    }
  },
  computed: {
    clUrl: function () {
      return `https://api.cloudinary.com/v1_1/${this.cloudinary.cloudName}/upload`
    }
  },
  methods: {
    upload (file) {
      const formData = new FormData()
      formData.append('file', file[0])
      formData.append('upload_preset', this.cloudinary.uploadPreset)
      formData.append('tags', 'gs-vue,gs-vue-uploaded')
      // For debug purpose only
      // Inspects the content of formData
      for (var pair of formData.entries()) {
        console.log(pair[0] + ', ' + pair[1])
      }
      // Execute api
      axios.post(this.clUrl, formData).then(res => {
        console.log(res)
        this.imgUrl = res.data.secure_url
        alert('Success!!')
      })
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: calc(100vh - 231px);
  padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// TutorImg.vue?019b8b42